<template>
    <v-container>
        <div class="container-fluid">

            <v-row>
                <v-col lg=12 cols=12 style="margin: 0 auto;">
                    <v-card>
                        <v-card-title class="pa-5 pb-3 primary">
                            <v-icon class="pr-4" :color="'#FFFFFF'">mdi-upload</v-icon>
                            <p style="color: white;">Carga Reportes de GNP</p>
                            <v-spacer></v-spacer>
                        </v-card-title>

                        <v-card-text class="pa-5 pt-4">
                            <br />
                            <v-row>
                                <v-col md="6" offset-md="3">
                                    <span style="color: black; text-align: center;">Nota:</span>
                                    <div>La carga masiva es para los reportes de GNP para realizar el tramite de pago.</div>

                                </v-col>
                            </v-row>
                            <v-form id="CargaLayout"
                                    ref="form"
                                    v-model="valid"
                                    lazy-validation>
                                <v-row class="mb-6" style="margin-bottom: 0px !important; height: 100px;">
                                    <v-col md="6" offset-md="3">

                                        <span style="color: black; text-align: center;">Archivo:</span>
                                        <v-file-input v-model="file"
                                                      @change="onChange"
                                                      color="primary"
                                                      :rules="rules"
                                                      prepend-icon="mdi-paperclip"
                                                      outlined
                                                      accept=".xlsx, .xls"
                                                      required
                                                      :disabled="disabledfile"
                                                      name="file">
                                            <template v-slot:selection="{ index, text }">
                                                <v-chip v-if="index < 2"
                                                        color="primary"
                                                        dark
                                                        label
                                                        small>
                                                    {{ text }}
                                                </v-chip>
                                                <span v-else-if="index === 2"
                                                      class="text-overline grey--text text--darken-3 mx-2">
                                                    {{ file.length - 2 }} File(s)
                                                </span>
                                            </template>
                                        </v-file-input>
                                    </v-col>
                                </v-row>
                                <br />
                            </v-form>
                            <v-row justify="center" class="mb-8">
                                <div>
                                    <v-btn class="ma-2"
                                           color="primary"
                                           @click="GuardarDatos()"
                                           :disabled="disabledSave">
                                        Guardar
                                    </v-btn>
                                    <v-btn class="ma-2"
                                           @click="reset()"
                                           :disabled="disabledClean">
                                        Limpiar
                                    </v-btn>
                                </div>
                            </v-row>
                        </v-card-text>
                        <v-card-text class="pa-1 pt-4" v-if="show == true">
                            <v-col md="8" offset-md="2">
                                <v-data-table :headers="headers"
                                              :items="DataError"
                                              no-data-text="No hay datos disponibles"
                                              :items-per-page="20"
                                              loading-text="Cargando.... espere"
                                              class="elevation-1"
                                              :style="{float: 'none', margin: '0 auto', width: '100%'}"
                                              :footer-props="{
                                                  'items-per-page-options': [20, 50, 100],
                                                  'items-per-page-text':'Registros por página'
                                                }">
                                </v-data-table>
                            </v-col>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </div>
    </v-container>
</template>
<script>
    import { mapGetters, mapState } from 'vuex';
    import * as XLSX from 'xlsx/xlsx.mjs';
    import JsonExcel from 'vue-json-excel';
    import service from '@/services/TramitePago/TramitePago.Service.js';

    export default {
        components: {
            JsonExcel
        },
        data() {
            return {
                valid: true,
                file: null,
                rules: [
                    v => {
                        if (v == null) {
                            return 'Archivo requerido'
                        }
                        else {
                            return true
                        }
                    }
                ],
                disabledfile: false,
                disabledSave: true,
                disabledClean: false,
                show: false,
                headers: [
                    { text: 'Reporte', value: 'nrreporte', class: "text title" },
                    { text: 'Indice', value: 'svindice', class: "text title" },
                    { text: 'Error', value: 'error', class: "text title" },
                ],
                DataError: [],
                Datos: [],
            }
        },
        computed: {
            ...mapGetters(['getUser', 'THEME_STATE']),
            ...mapState({ drawer: state => state.drawer }),
            ...mapState(['domain', 'informationPage', 'permission']),
            DRAWER_STATE: {
                get() {
                    return this.drawer
                },
            }
        },
        methods: {
            async onChange(e) {
                this.disabledSave = true;
                this.disabledClean = true;
                this.disabledfile = true;
                if (this.file != null) {
                    
                    if (this.file.size > 500) {
                        var files = e, f = e;
                        var reader = new FileReader();
                        var vm = this;
                        reader.onload = async function (e) {
                            var data = new Uint8Array(e.target.result);
                            var workbook = XLSX.read(data, { type: 'array' });
                            let sheetName = workbook.SheetNames[0];
                            let worksheet = workbook.Sheets[sheetName];
                            let datos = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                            console.log(datos);
                            const header = datos.shift();
                            if (datos.length > 0) {
                                if ((header[0] == 'Reporte' && header[1] == 'Indice') /*|| (header[0] == 'Reporte' && header[1] == 'Indice')*/) {
                                    let dat = XLSX.utils.sheet_to_json(worksheet);
                                    vm.Datos = dat;
                                    if (dat.length > 0) {

                                        vm.$swal({
                                            position: 'center',
                                            title: 'Validando Información, espere un momento....',
                                            allowEscapeKey: false,
                                            allowOutsideClick: false,
                                            didOpen: () => {
                                                vm.$swal.showLoading();
                                            }
                                        });
                                        let formdata = new FormData();
                                        formdata.append("data", JSON.stringify(dat));
                                        await service.ValidarGnp(vm, formdata).then(data => {
                                            setTimeout(() => {
                                                vm.$swal.close();
                                                if (data.error == false) {
                                                    vm.DataError = data.data;
                                                    if (data.data.length == 0) {
                                                        vm.show = false;
                                                        vm.disabledSave = false;
                                                    }
                                                    else {
                                                        vm.show = true;
                                                        vm.disabledSave = true;
                                                        vm.$swal({
                                                            position: 'center',
                                                            icon: 'info',
                                                            title: 'Advertencia',
                                                            text: 'Verifique los errores de la tabla para poder realizar la carga.',
                                                            showConfirmButton: true,
                                                            allowOutsideClick: false,
                                                            allowEscapeKey: false
                                                        })
                                                    }
                                                }
                                                else {
                                                    vm.$swal({
                                                        position: 'center',
                                                        icon: 'info',
                                                        title: 'Advertencia',
                                                        text: data.msg,//'Verifique los errores de la tabla para poder realizar la carga.',
                                                        showConfirmButton: true,
                                                        allowOutsideClick: false,
                                                        allowEscapeKey: false
                                                    })
                                                }
                                                //vm.file = null;

                                                vm.disabledClean = false;
                                            }, 1500);

                                        });
                                        //})
                                    }
                                }
                                else {
                                    vm.$swal({
                                        position: 'center',
                                        icon: 'error',
                                        title: 'Formato Incorrecto',
                                        text: 'Seleccione otro archivo',
                                        showConfirmButton: true,
                                        timer: 3000,
                                        allowOutsideClick: false,
                                        allowEscapeKey: false
                                    });//.then((result) => {
                                    //if (result.isConfirmed) {
                                    vm.data = Array;
                                    vm.file = null;
                                    vm.reset();
                                    vm.disabledSave = true;
                                    vm.disabledClean = false;
                                    //}
                                    //});
                                }
                            }
                            else {
                                vm.$swal({
                                    position: 'center',
                                    icon: 'error',
                                    title: 'Formato Incorrecto',
                                    text: 'No se encontro registros',
                                    showConfirmButton: true,
                                    timer: 3000,
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                });
                                vm.data = Array;
                                vm.file = null;
                                vm.reset();
                                vm.disabledSave = true;
                                vm.disabledClean = false;
                            }
                        }
                        reader.readAsArrayBuffer(f);
                    }
                }
            },
            GuardarDatos() {
                if (this.Datos.length > 0) {
                    let formdata = new FormData();
                    formdata.append("data", JSON.stringify(this.Datos));
                    service.CargarGnp(this, formdata).then(data => {
                        if (data.error == false) {
                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                text: 'Los registros se guardaron correctamente',
                                showConfirmButton: true,
                                timer: 3000,
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            });
                            this.DataError = [];
                            this.show = false;
                            this.file = null;
                            this.disabledSave = true;
                        }
                        else {
                            this.$swal({
                                position: 'center',
                                icon: 'error',
                                text: 'Existió un error, inténtelo más tarde',
                                showConfirmButton: true,
                                timer: 3000,
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            });
                        }
                    });
                }
                else {
                    this.$swal({
                        position: 'center',
                        icon: 'error',
                        text: 'No existe registros',
                        showConfirmButton: true,
                        timer: 3000,
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    });
                }
            },
            reset() {
                this.DataError = [];
                this.show = false;
                this.file = null;
                this.disabledSave = true;
                this.disabledfile = false;
            }
        }
    }
</script>